import type * as React from 'react';
import {type DigitalCode} from '@/types/DigitalCode';
import {MaterialReactTable} from 'material-react-table';
import {Stack} from '@mui/material';
import Box from '@mui/material/Box';
import DialogGetDigitalCode from '@/components/DigitalCode/DialogGetDigitalCode';

type Props = {
    digitalCodes : DigitalCode[];
};

const TableDigitalCodes = ({digitalCodes} : Props) : React.ReactElement => {
    const columns = [
        {
            accessorKey: 'course',
            header: 'Course',
            sort: true,
        },
        {
            accessorKey: 'description',
            header: 'Description',
            sort: true,
        },
    ];

    return <MaterialReactTable
        columns={columns}
        data={digitalCodes}

        enableColumnActions={false}
        enableColumnFilters={false}
        enableDensityToggle={false}
        enableFilterMatchHighlighting={false}
        enableFullScreenToggle={false}
        enableGlobalFilter={false}
        enableHiding={false}

        positionActionsColumn={'last'}
        enableRowActions
        displayColumnDefOptions={{
            'mrt-row-actions': {
                size: 250,
            },
        }}
        renderRowActions={({row}) => {
            const originalRow = row.original;

            return <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px'}}>
                <DialogGetDigitalCode digitalCode={originalRow}/>
            </Box>
        }}

        renderTopToolbarCustomActions={() => <Stack
            sx={{
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <Stack
                sx={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    width: '100%',
                }}
            >
                <Box sx={{typography: 'h5', p: 2}}>My Digital Codes</Box>
            </Stack>
        </Stack>}
    />;
};

export default TableDigitalCodes;
